import { prefix } from '@util/imagePrefix';
import Link from 'next/link';

export const AektivTradeInSection = () => {
  return (
    <div
      className="relative flex h-[30rem] w-full overflow-hidden sm:mx-auto sm:max-w-[150rem] rounded-[2rem]"
      style={{
        backgroundImage: `url(${prefix}/assets/aektiv-homepage-section-bg_1920x2560.png)`,
        backgroundSize: 'cover',
        backgroundPosition: 'right center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="flex h-full flex-col items-start justify-center gap-y-8 pl-12">
        <div className="flex flex-col items-start gap-y-2">
          <span className="text-[1.8rem] font-medium text-white">
            Aektiv Trade-In Program
          </span>
          <span className="w-[40rem] text-[2.7rem] font-bold text-white">
            Trade in Your Used Gear, for New Gear!
          </span>
        </div>

        <Link
          href={'/aektiv-trade-in-program'}
          className="flex h-[5rem] items-center rounded-[1.5rem] bg-brand-secondary px-8 py-2 text-[1.8rem] font-medium text-white transition-colors duration-150 ease-out hover:bg-brand-secondary-darker"
        >
          Trade Now!
        </Link>
      </div>
    </div>
  );
};
